import { useEffect, useRef, useState } from "react";
import { SignIn, useAuth } from "@clerk/react-router";
import { useNavigate } from "react-router-dom";
import { LoadingIndicator } from "@/components/application/loading-indicator/loading-indicator";

export default function LoginPage() {
    const navigate = useNavigate();
    const { isSignedIn, isLoaded } = useAuth();

    // Track if we've ever loaded - once true, never show loading again
    const hasInitiallyLoaded = useRef(false);
    const [isReady, setIsReady] = useState(false);

    // Mark as ready once Clerk loads for the first time
    useEffect(() => {
        if (isLoaded && !hasInitiallyLoaded.current) {
            hasInitiallyLoaded.current = true;
            setIsReady(true);
        }
    }, [isLoaded]);

    // Redirect to home if already signed in (only check once loaded)
    useEffect(() => {
        if (hasInitiallyLoaded.current && isSignedIn) {
            navigate("/home", { replace: true });
        }
    }, [isLoaded, isSignedIn, navigate]);

    // Only show loading on the very first load, never again
    if (!isReady) {
        return (
            <div className="flex h-screen w-full items-center justify-center bg-secondary">
                <LoadingIndicator size="lg" label="Loading..." />
            </div>
        );
    }

    // Show redirecting state if signed in
    if (isSignedIn) {
        return (
            <div className="flex h-screen w-full items-center justify-center bg-secondary">
                <LoadingIndicator size="lg" label="Signing you in..." />
            </div>
        );
    }

    return (
        <div className="flex min-h-screen flex-col items-center justify-center bg-secondary px-4 py-12 sm:px-6 lg:px-8">
            <div className="sm:mx-auto sm:w-full sm:max-w-md">
                <div className="mb-6 flex flex-col items-center">
                    <img src="/logo.png" alt="AutoLedger" className="mb-3 h-16 w-16" />
                    <p className="text-md font-medium text-secondary">AutoLedger</p>
                </div>

                <div className="flex justify-center">
                    <SignIn
                        routing="path"
                        path="/login"
                        signUpUrl={null}
                        forceRedirectUrl="/home"
                        appearance={{
                            elements: {
                                rootBox: "w-full",
                                card: "bg-primary shadow-xl rounded-xl border border-secondary",
                                headerTitle: "text-primary",
                                headerSubtitle: "text-secondary",
                                socialButtonsBlockButton: "border-secondary hover:bg-secondary",
                                socialButtonsBlockButtonText: "text-primary",
                                dividerLine: "bg-secondary",
                                dividerText: "text-tertiary",
                                formFieldLabel: "text-secondary",
                                formFieldInput: "bg-primary border-secondary text-primary focus:ring-brand-primary focus:border-brand-primary",
                                footerActionLink: "text-brand-primary hover:text-brand-primary_alt",
                                formButtonPrimary: "bg-brand-solid hover:bg-brand-solid_hover",
                                identityPreviewEditButton: "text-brand-primary",
                                footer: "hidden",
                            },
                        }}
                    />
                </div>
            </div>
        </div>
    );
}
